import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';

const checkStyle = {
  marginTop: -10,
  marginBottom: 16
};
const styles = {
  label: {
    fontSize: 16,
    color: '#666'
  },
  hiddenLabel: {
    visibility: 'hidden'
  }
};
const RadioContainer = ({ checkId, checked = false, onCheck, classes, hideLabel, disabled }) => {
  return (
    <div className="checkbox-container">
      <div className="checkbox-background" />
      <FormControlLabel
        style={checkStyle}
        classes={{
          label: hideLabel ? classes.hiddenLabel : classes.label
        }}
        control={<Radio disabled={disabled} checked={checked} onChange={onCheck} color={'primary'} />}
        label={checkId}
      />
    </div>
  );
};

RadioContainer.propTypes = {
  checkId: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(RadioContainer);
